import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineCodeBranchIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M17 6.06a3 3 0 0 0-1.15 5.7699 1.9992 1.9992 0 0 1-1.85 1.23h-4a3.911 3.911 0 0 0-2 .56v-5.74a3 3 0 1 0-2 0v8.36a2.9998 2.9998 0 0 0-1.946 3.3041 3 3 0 1 0 4.106-3.2541 2.0002 2.0002 0 0 1 1.84-1.23h4a3.9997 3.9997 0 0 0 3.91-3.16 2.9996 2.9996 0 0 0 1.9991-3.3024A3 3 0 0 0 17 6.06Zm-10-2a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm0 15.9999a.9998.9998 0 0 1-.9808-1.195 1.0004 1.0004 0 0 1 .7857-.7857A.9998.9998 0 0 1 8 19.0599a.9998.9998 0 0 1-1 1Zm10-10a1 1 0 1 1-.0001-2.0001A1 1 0 0 1 17 10.0599Z"/>
  </SvgIcon>
}

export default LineCodeBranchIcon
